import { Image, Typography } from "antd";
import QuixLogo from "assets/Logo.png";
import classes from "./styles.module.css";
import { useEffect } from "react";
import { Link } from "react-router-dom";

const termsAndConditions = `
  <style>
    * {
        margin: 0;
        padding: 0;
        text-indent: 0;
    }
    h1 {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 24pt;
    }
    h3 {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 14pt;
        margin-top: 20px
    }
    .p,
    p {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
        margin: 0pt;
        line-height: 2;
    }
    .s2 {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 8pt;
        vertical-align: 1pt;
    }
    .s3 {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 9pt;
    }
    .a,
    a {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    .s5 {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 9pt;
    }
    .s6 {
        color: white;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 12pt;
    }
    .s7 {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: underline;
        font-size: 10pt;
    }
    .s8 {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 10pt;
    }
    .s9 {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 10pt;
        padding: 4pt
    }
    .s10 {
        color: "#00f";
        font-family: Wingdings;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 9pt;
    }
    h2 {
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 16pt;
    }
    li {
        display: block;
    }
    #l1 {
        padding-left: 0pt;
        counter-reset: c1 1;
    }
    #l1 > li > *:first-child:before {
        counter-increment: c1;
        content: counter(c1, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 14pt;
    }
    #l1 > li:first-child > *:first-child:before {
        counter-increment: c1 0;
    }
    #l2 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l2 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l2 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l3 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l3 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l3 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l4 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l4 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l4 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l5 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l5 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l5 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l6 {
        padding-left: 0pt;
        counter-reset: c4 1;
    }
    #l6 > li > *:first-child:before {
        counter-increment: c4;
        content: "(" counter(c4, lower-roman) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l6 > li:first-child > *:first-child:before {
        counter-increment: c4 0;
    }
    #l7 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l7 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l7 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l8 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l8 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l8 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l9 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l9 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l9 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l10 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l10 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l10 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l11 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l11 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l11 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l12 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l12 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l12 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l13 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l13 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l13 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l14 {
        padding-left: 0pt;
        counter-reset: c4 1;
    }
    #l14 > li > *:first-child:before {
        counter-increment: c4;
        content: "(" counter(c4, lower-roman) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l14 > li:first-child > *:first-child:before {
        counter-increment: c4 0;
    }
    #l15 {
        padding-left: 0pt;
        counter-reset: d1 1;
    }
    #l15 > li > *:first-child:before {
        counter-increment: d1;
        content: "(" counter(d1, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l15 > li:first-child > *:first-child:before {
        counter-increment: d1 0;
    }
    #l16 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l16 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l16 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l17 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l17 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l17 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l18 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l18 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l18 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l19 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l19 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l19 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l20 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l20 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l20 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l21 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l21 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l21 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l22 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l22 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l22 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l23 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l23 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l23 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l24 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l24 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l24 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l25 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l25 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l25 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l26 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l26 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l26 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l27 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l27 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l27 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l28 {
        padding-left: 0pt;
        counter-reset: c3 1;
    }
    #l28 > li > *:first-child:before {
        counter-increment: c3;
        content: "(" counter(c3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l28 > li:first-child > *:first-child:before {
        counter-increment: c3 0;
    }
    #l29 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l29 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l29 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l30 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l30 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l30 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l31 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l31 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l31 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l32 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l32 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l32 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l33 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l33 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l33 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l34 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l34 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l34 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    #l35 {
        padding-left: 0pt;
        counter-reset: c2 1;
    }
    #l35 > li > *:first-child:before {
        counter-increment: c2;
        content: counter(c1, decimal) "." counter(c2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l35 > li:first-child > *:first-child:before {
        counter-increment: c2 0;
    }
    li {
        display: block;
    }
    #l36 {
        padding-left: 0pt;
        counter-reset: e1 1;
    }
    #l36 > li > *:first-child:before {
        counter-increment: e1;
        content: counter(e1, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: bold;
        text-decoration: none;
        font-size: 14pt;
    }
    #l36 > li:first-child > *:first-child:before {
        counter-increment: e1 0;
    }
    #l37 {
        padding-left: 0pt;
        counter-reset: e2 1;
    }
    #l37 > li > *:first-child:before {
        counter-increment: e2;
        content: counter(e1, decimal) "." counter(e2, decimal) " ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l37 > li:first-child > *:first-child:before {
        counter-increment: e2 0;
    }
    #l38 {
        padding-left: 0pt;
        counter-reset: e3 1;
    }
    #l38 > li > *:first-child:before {
        counter-increment: e3;
        content: "(" counter(e3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l38 > li:first-child > *:first-child:before {
        counter-increment: e3 0;
    }
    #l39 {
        padding-left: 0pt;
        counter-reset: e3 1;
    }
    #l39 > li > *:first-child:before {
        counter-increment: e3;
        content: "(" counter(e3, lower-latin) ") ";
        color: white;
        font-family: "Titillium web", sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l39 > li:first-child > *:first-child:before {
        counter-increment: e3 0;
    }
    #l40 {
        padding-left: 0pt;
        counter-reset: e4 1;
    }
    #l40 > li > *:first-child:before {
        counter-increment: e4;
        content: "(" counter(e4, lower-roman) ") ";
        color: white;
        font-family: Arial, sans-serif;
        font-style: normal;
        font-weight: normal;
        text-decoration: none;
        font-size: 14pt;
    }
    #l40 > li:first-child > *:first-child:before {
        counter-increment: e4 0;
    }
    table,
    tbody {
        vertical-align: top;
        overflow: visible;
    }
</style>
<body>
    <h1 style="padding-top: 1pt; text-indent: 0pt;"><a name="bookmark0">‌</a>Terms and Conditions</h1>
    <ol id="l1">
        <li data-list-text="1.">
            <h3 style="padding-top: 3pt ; text-align: justify;"><a name="bookmark1">‌</a>Definitions and interpretation</h3>
            <ol id="l2">
                <li data-list-text="1.1">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark2">‌</a>In this Agreement, the following terms have the following meanings unless the context requires otherwise:
                    </p>
                    <h3 style="padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Agreement
                        <span class="p">: these Terms and Conditions and Schedule 1 (Data Processing Agreement) as well as the provisions set out in any other attached Schedules or documents incorporated into a Schedule by reference.</span>
                    </h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Applicable Law
                        <span class="p">
                            : all laws, legislation, regulations, statutes, statutory instruments, rules, regulations, edicts, by-laws or directions or guidance from government or governmental agencies applicable to QuiX Quantum or the
                            Customer, in effect from time to time.
                        </span>
                    </h3>
                    <h3 style="padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Confidential Information
                        <span class="p">
                            : all confidential, scientific, technical, financial, business and other information, all manufacturing, marketing, sales and distribution data, all scientific and test data, documents, methods, techniques,
                            formulations, operations, know-how, experience, skills, trade secrets, computer programs and systems, processes, practices, ideas, inventions, designs, samples, plans and drawings.
                        </span>
                    </h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Controller, Processor, data subject, personal data, personal data breach, processing and appropriate technical and organizational measures<span class="p">: as defined in the GDPR.</span>
                    </h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Customer Data
                        <span class="p">: the data input by the Customer, its representatives, or QuiX Quantum on the Customer's behalf for the purpose of using the Services or facilitating the Customer's use of the Services.</span>
                    </h3>
                    <h3 style="padding-left: 43pt; text-indent: 0pt; text-align: justify;">Data Importer<span class="p">: the relevant entity identified in the Standard</span></h3>
                    <p style="padding-left: 43pt; text-indent: 0pt; text-align: justify;">Contractual Clauses.</p>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">Data Exporter<span class="p">: the relevant entity that transfers personal data</span></h3>
                    <p style="padding-left: 43pt; text-indent: 0pt; text-align: justify;">from the European Economic Area to the Data Importer.</p>
                    <h3 style="padding-left: 43pt; text-indent: 0pt; text-align: left;">
                        Data Protection Laws
                        <span class="p">
                            : the Netherlands Data Protection Laws and any other Applicable Laws of the European Union, the European Economic Area, and their member states relating to the processing of personal data and all other
                            legislation and regulatory requirements in force from time to time which apply to a party relating to the processing of personal data (including, without limitation, the privacy of electronic communications).
                        </span>
                        Derived Data
                        <span class="p">
                            : any information or data resulting from manipulation or analysis of the Customer Data and Customer’s use of the Services, whether alone or in conjunction with other data, provided that such information or data
                            is not capable of being used to identify the Customer or its representatives.
                        </span>
                    </h3>
                    <h3 style="padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Documentation
                        <span class="p">
                            : the Service Description and other documents which may be made available to the Customer by QuiX Quantum from time to time and which set out the user instructions for the Services, all of which as may be varied
                            by QuiX Quantum and notified to the Customer from time to time.
                        </span>
                    </h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">Effective Date<span class="p">: the date that the Customer accepts the Terms and Conditions.</span></h3>
                    <p style="padding-left: 43pt; text-indent: 0pt; text-align: left;"></p>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Intellectual Property Rights
                        <span class="p">
                            : any patent, copyright, trade mark, service mark or trade name, utility model, right in software, right in design, right in databases, image right, moral right, right in an invention, right relating to passing
                            off, domain name, right in confidential information (including trade secrets) or right of privacy, and all similar or equivalent rights in each case whether registered or not and including all applications (or
                            rights to apply) for, or renewal or extension of, such rights which exist now or which will exist in the future in the United Kingdom and all other countries in the world.
                        </span>
                    </h3>
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        <b>Netherlands Data Protection Laws</b>: all applicable data protection and privacy legislation in force from time to time in the Netherlands including the General Data Protection Regulation ((EU) 2016/679) (
                        <i>Algemene verordening gegevensbescherming (AVG)</i>); and the Telecommunications Act (<i>Telecommunicatiewet</i>) as amended.
                    </p>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Platform<span class="p">: the cloud-based environment accessible via quixquantum.com through which the Customer may submit Tasks.</span>
                    </h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Regulator<span class="p">: any supervisory authority with authority under Data Protection Laws over the processing of personal data, and which may be under development during the execution of the agreement.</span>
                    </h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Service Description
                        <span class="p">
                            : QuiX Quantum provides the use of its near- term photon quantum computer via cloud access, for the Customer to perform quantum photonic calculations by submitting jobs in a format determined by QuiX Quantum. The
                            Service Description may be varied by QuiX Quantum and notified to the Customer from time to time.
                        </span>
                    </h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Standard Contractual Clauses
                        <span class="p">
                            : the agreement in the form annexed to the European Commission's decision of 4 June 2021 on Standard Contractual Clauses for the transfer of personal data to processors established in third countries.
                        </span>
                    </h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">Subscription Credits<span class="p">: the subscription credits to be allocated by QuiX Quantum to the Customer.</span></h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">Subscription Term<span class="p">: is the term of the agreement as stipulated in clause 15.</span></h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Task
                        <span class="p">
                            : calculation to be submitted by the Customer through the Platform in a format determined by QuiX Quantum from time to time and to be completed by QuiX Quantum as set out in the Service Description.
                        </span>
                    </h3>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Virus
                        <span class="p">
                            : any software, code, file, programme, or device which may: prevent, impair or otherwise adversely affect the operation of any computer software, hardware or network, any telecommunications service, equipment or
                            network or any other service or device; prevent, impair or otherwise adversely affect access to or the operation of any programme or data, including the reliability of any programme or data (whether by re-
                            arranging, altering or erasing the programme or data in whole or part or otherwise); or adversely affect the user experience, including worms, trojan horses, viruses and other similar things or devices.
                        </span>
                    </h3>
                    <p style="padding-top: 2pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;"></p>
                    <h3 style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        Vulnerability
                        <span class="p">
                            : a weakness in the computational logic (for example, code) found in software or hardware components that when exploited, results in a negative impact to the confidentiality, integrity, or availability, and the
                            term Vulnerabilities shall be construed accordingly.
                        </span>
                    </h3>
                </li>
            </ol>
        </li>
        <li data-list-text="2.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark3">‌</a>License and access<a name="bookmark20">‌</a></h3>
            <ol id="l3">
                <li data-list-text="2.1">
                    <p style="padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a href="#bookmark20" class="a" name="bookmark4">Subject to the restrictions set out in this clause </a>2 and the other terms and conditions of this Agreement, QuiX Quantum hereby grants to the Customer a
                        non-exclusive, non-transferable right, without the right to grant sublicences, to permit its representatives to use the Platform and the Documentation during the Subscription Term, in order to test the capabilities
                        of the Platform and for research purposes.
                    </p>
                </li>
                <li data-list-text="2.2">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark5">‌</a>The Customer shall not access, store, distribute or transmit any Viruses, or any material during the course of its use of the Services that:
                    </p>
                    <ol id="l4">
                        <li data-list-text="(a)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark6">‌</a>is unlawful, harmful, threatening, defamatory, obscene, harassing or racially or ethnically offensive;</p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark7">‌</a>facilitates illegal activity;</p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark8">‌</a>is discriminatory based on race, gender, colour, religious
                            , sexual orientation, disability; or</p>
                        </li>
                        <li data-list-text="(d)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark9">‌</a>is otherwise illegal or causes damage or injury to any person or property.</p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="2.3">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -33pt; text-align: justify;"><a name="bookmark10">‌</a>The Customer shall not, and shall not permit any third party:</p>
                    <ol id="l5">
                        <li data-list-text="(a)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark11">‌</a>except as may be allowed by any Applicable Law which is incapable of exclusion by agreement between the Parties:
                            </p>
                            <ol id="l6">
                                <li data-list-text="(i)">
                                    <p style="padding-left: 100pt; text-indent: -28pt; text-align: justify;">
                                        <a name="bookmark12">‌</a>attempt to copy, modify, duplicate, create derivative works from, frame, mirror, republish, download, display, transmit, or distribute all or any portion of the software as
                                        provided as part of the Services and/or Documentation (as applicable) in any form or media or by any means; or
                                    </p>
                                </li>
                                <li data-list-text="(ii)">
                                    <p style="padding-left: 100pt; text-indent: -28pt; text-align: justify;">
                                        <a name="bookmark13">‌</a>attempt to de-compile, reverse compile, disassemble, reverse engineer or otherwise reduce to human-perceivable form all or any part of the software as provided as part of the
                                        Services; or
                                    </p>
                                </li>
                            </ol>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark14">‌</a>access all or any part of the Services and Documentation in order to build a product or service which competes with the Services and/or the Documentation; or
                            </p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-top: 2pt; padding-left: 72pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark15">‌</a>license, sell, rent, lease, transfer, assign, distribute, display, disclose, or otherwise commercially exploit, or otherwise make the Services and/or Documentation available to any
                                third party, or
                            </p>
                        </li>
                        <li data-list-text="(d)">
                            <p style="padding-left: 72pt; text-indent: -28pt; text-align: justify;">
                                <a href="#bookmark20" class="a" name="bookmark16">attempt to obtain, or assist third parties in obtaining, access to the Services and/or Documentation, other than as provided under this clause </a>2; or
                            </p>
                        </li>
                        <li data-list-text="(e)">
                            <p style="padding-top: 1pt; padding-left: 72pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark17">‌</a>introduce or permit the introduction of, any Virus or Vulnerability into QuiX Quantum's network and information systems.
                            </p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="2.4">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark18">‌</a>The Customer shall prevent any unauthorised access to, or use of, the Services and/or the Documentation and, in the event of any such unauthorised access or use, promptly notify QuiX
                        Quantum.
                    </p>
                </li>
                <li data-list-text="2.5">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -33pt; text-align: justify;">
                        <a href="#bookmark20" class="a" name="bookmark19">
                            Without prejudice to QuiX Quantum’s other rights or remedies, QuiX Quantum may suspend the Customer’s access to the Services if there is a breach of this clause 2 or if suspension is reasonably required due to a
                            threat to the security or integrity of the Services or QuiX Quantum’s systems, during maintenance or development of the Services, or for another reason in QuiX Quantum’s sole discretion. QuiX Quantum will
                            endeavour to provide advance written notice of a suspension and to restore access to the Services once the issue resulting in the suspension has been resolved to QuiX Quantum’s satisfaction. A breach of this
                            clause
                        </a>
                        <a href="#bookmark118" class="a">2 by the Customer or its representatives also constitutes a material breach by the Customer for the purposes of clause </a><a href="#bookmark118">15.3.</a>
                    </p>
                </li>
                <li data-list-text="2.6">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -33pt; text-align: justify;">
                        QuiX Quantum reserves the rights to grant access to the services as described in this Agreement at its sole discreption.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="3.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark21">‌</a>Subscription Credits</h3>
            <ol id="l7">
                <li data-list-text="3.1">
                    <p style="padding-left: 43pt; text-indent: -33pt; text-align: justify;">
                        <a name="bookmark22">‌</a>The Customer shall be allotted a fixed number of Subscription Credits to be used to submit Tasks, as determined by QuiX Quantum.<a name="bookmark25">‌</a>
                    </p>
                </li>
                <li data-list-text="3.2">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a href="#bookmark25" class="a" name="bookmark23">The Customer may purchase additional Subscription Credits in excess of those allotted to the Customer pursuant to clause </a>3.1 (<b>Additional Credits</b>) and QuiX
                        Quantum shall handle all such requests in good faith, provided that QuiX Quantum may require the Customer to pay an amount to be determined by QuiX Quantum for each additional Subscription Credit<i><b>.</b></i>
                    </p>
                </li>
                <li data-list-text="3.3">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark24">‌</a>Subscription Credits have no cash value or any other value outside of the Platform and are not redeemable for cash. For the avoidance of doubt, the Subscription Credits do not operate or
                        serve as stored value facilities in any way. The Customer may not transfer, trade, gift or otherwise exchange Subscription Credits.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="4.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark26">‌</a>Tasks</h3>
            <ol id="l8">
                <li data-list-text="4.1">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -33pt; text-align: justify;"><a name="bookmark27">‌</a>The Customer may submit Tasks through the Platform in a format to be determined and provided by QuiX Quantum.</p>
                </li>
                <li data-list-text="4.2">
                    <p style="padding-left: 43pt; text-indent: -33pt; text-align: justify;">
                        <a name="bookmark28">‌</a>The exact number of Tasks the Customer shall be able to submit through the Platform shall depend on the number of Subscription Credits required to carry out each Task, as determined by QuiX
                        Quantum based on <i>inter alia </i>the expected duration of the Task.
                    </p>
                </li>
                <li data-list-text="4.3">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -33pt; text-align: justify;"><a name="bookmark29">‌</a>The Customer may choose to proceed with or cancel the Task until the Task has been completed.</p>
                </li>
                <li data-list-text="4.4">
                    <p style="padding-top: 2pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark30">‌</a>If the Customer chooses to cancel the Task, the number of Subscriptions Credits that have been used to carry out such Task until the cancellation shall be deducted from the Customer’s online
                        account.
                    </p>
                </li>
                <li data-list-text="4.5">
                    <p style="padding-left: 43pt; text-indent: -33pt; text-align: justify;">
                        <a href="#bookmark34" class="a" name="bookmark31">Subject to clause </a>4.6, QuiX Quantum shall handle all submitted Tasks in good faith and shall use reasonable endeavours to ensure that Tasks are carried out in
                        order of acceptance and as soon as is reasonably practicable.
                    </p>
                </li>
                <li data-list-text="4.6">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark32">‌</a>QuiX Quantum retains the right to delay and prioritise Tasks at its discretion, including in the event it requires use of the Services for its own internal business purposes or for other
                        users.<a name="bookmark34">‌</a>
                    </p>
                </li>
                <li data-list-text="4.7">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -33pt; text-align: justify;"><a name="bookmark33">‌</a>The Customer shall be notified once a Task has been completed shall be able to access the results via the Platform.</p>
                </li>
            </ol>
        </li>
        <li data-list-text="5.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark35">‌</a>Services</h3>
            <ol id="l9">
                <li data-list-text="5.1">
                    <p style="padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark36">‌</a>QuiX Quantum shall, during the Subscription Term, provide the Services and make available the Documentation to the Customer on and subject to the terms of this Agreement.
                    </p>
                </li>
                <li data-list-text="5.2">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -33pt; text-align: justify;">
                        <a name="bookmark37">‌</a>QuiX Quantum shall use reasonable endeavours to make the Services available to the Customer, except for during maintenance, further development, release of new version(s), or unavailability
                        for any other business reason provided that QuiX Quantum has used reasonable endeavours to notify the Customer up front by posting a notification on the Platform and/or its website.
                    </p>
                </li>
                <li data-list-text="5.3">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark38">‌</a>The Customer acknowledges that the completion of Tasks may be delayed as a result of unavailability of the Services.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="6.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark39">‌</a>Customer data</h3>
            <ol id="l10">
                <li data-list-text="6.1">
                    <p style="padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark40">‌</a>The Customer shall own all right, title and interest in and to all of the Customer Data that is not personal data and shall have sole responsibility for the legality, reliability, integrity,
                        accuracy and quality of all such Customer Data. The Customer grants QuiX Quantum a non-exclusive right to use and access Customer Data during the Subscription Term for the sole purpose of providing the Services.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="7.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark41">‌</a>Data protection</h3>
            <ol id="l11">
                <li data-list-text="7.1">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark42">‌</a>Both Parties shall process personal data in accordance with 1 and shall comply with all applicable requirements of the Data Protection Laws. For the avoidance of doubt, Schedule 1 is in
                        addition to, and does not relieve, remove or replace, a Party's obligations or rights under the Data Protection Laws.<a name="bookmark43">‌</a>
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="8.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark44">‌</a>QuiX Quantum's obligations</h3>
            <ol id="l12">
                <li data-list-text="8.1">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark45">‌</a>The Customer understands that the platform is still in development phase and is offered on a “as-is, where-is” basis without any warranties or commitments in respect of the availability,
                        functioning, nor in respect of the accurateness of its calculations. QuiX Quantum undertakes that the Services will be performed substantially in accordance with the Documentation and with reasonable skill and care.
                        QuiX Quantum may amend the Documentation at its sole discretion from time to time.<a name="bookmark53">‌</a>
                    </p>
                </li>
                <li data-list-text="8.2">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -33pt; text-align: justify;"><a name="bookmark46">‌</a>QuiX Quantum:</p>
                    <ol id="l13">
                        <li data-list-text="(a)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark47">‌</a>does not warrant that:</p>
                            <ol id="l14">
                                <li data-list-text="(i)">
                                    <p style="padding-top: 2pt; padding-left: 104pt; text-indent: -28pt; text-align: justify;"><a name="bookmark48">‌</a>the Customer's use of the Services will be uninterrupted;</p>
                                </li>
                                <li data-list-text="(ii)">
                                    <p style="padding-top: 1pt; padding-left: 104pt; text-indent: -28pt; text-align: justify;">
                                        <a name="bookmark49">‌</a>the Derived Data or results generated in the provision of the Services as provided to the Customer will be error-free;
                                    </p>
                                </li>
                                <li data-list-text="(iii)">
                                    <p style="padding-top: 1pt; padding-left: 104pt; text-indent: -28pt; text-align: justify;">
                                        <a name="bookmark50">‌</a>that the Services, Documentation and/or the information obtained by the Customer through the Services will meet the Customer's requirements; or
                                    </p>
                                </li>
                                <li data-list-text="(iv)">
                                    <p style="padding-left: 104pt; text-indent: -28pt; line-height: 12pt; text-align: justify;"><a href="#bookmark53" class="a" name="bookmark51">subject to clause </a>8.1, the Platform or the Services be free from Vulnerabilities; and</p>
                                </li>
                            </ol>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-top: 1pt; padding-left: 76pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark52">‌</a>is not responsible for any delays, delivery failures, or any other loss or damage resulting from the transfer of data over communications networks and facilities, including the
                                internet, and the Customer acknowledges that the Services and Documentation may be subject to limitations, delays and other problems inherent in the use of such communications facilities.
                            </p>
                        </li>
                    </ol>
                </li>
            </ol>
        </li>
        <li data-list-text="9.">
            <h3 style="text-align: justify;"><a name="bookmark54">‌</a>Customer's obligations</h3>
            <p style="padding-top: 1pt; padding-left: 48pt; text-indent: 0pt; text-align: justify;">The Customer shall:</p>
            <ol id="l15">
                <li data-list-text="(a)">
                    <p style="padding-top: 1pt; padding-left: 76pt; text-indent: -28pt; text-align: justify;"><a name="bookmark55">‌</a>provide QuiX Quantum with all necessary co-operation in relation to this Agreement;</p>
                </li>
                <li data-list-text="(b)">
                    <p style="padding-top: 1pt; padding-left: 76pt; text-indent: -28pt; text-align: justify;">
                        <a name="bookmark56">‌</a>without affecting its other obligations under this Agreement, comply with all Applicable Laws with respect to its use of the Services;
                    </p>
                </li>
                <li data-list-text="(c)">
                    <p style="padding-top: 1pt; padding-left: 76pt; text-indent: -28pt; text-align: justify;">
                        <a name="bookmark57">‌</a>be responsible for breach of this Agreement made by any user accessing the Services with user credentials of the Customer (unless in case of a cyber incident not related to, or caused by,
                        actions or omissions by the Customer).
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="10.">
            <h3 style="padding-top: 1pt; text-align: justify;"><a name="bookmark58">‌</a>Charges and payment</h3>
            <ol id="l16">
                <li data-list-text="10.1">
                    <p style="padding-top: 1pt; padding-left: 48pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark59">‌</a>In the event that fees are due in consideration for the allotment of Additional Credits, the Customer shall pay these fees in advance.
                    </p>
                </li>
                <li data-list-text="10.2">
                    <p style="padding-top: 1pt; padding-left: 48pt; text-indent: -38pt; text-align: justify;"><a name="bookmark60">‌</a>All amounts and fees stated or referred to in this Agreement:</p>
                    <ol id="l17">
                        <li data-list-text="(a)">
                            <p style="padding-top: 1pt; padding-left: 76pt; text-indent: -28pt; text-align: justify;"><a name="bookmark61">‌</a>shall be denominated in and payable in euros;</p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-left: 76pt; text-indent: -28pt; text-align: justify;"><a href="#bookmark111" class="a" name="bookmark62">are, subject to clause </a>14.3, non-cancellable and non- refundable;</p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-top: 1pt; padding-left: 76pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark63">‌</a>are exclusive of value added tax or any other applicable tax or duty, which shall be added to QuiX Quantum's invoice(s) at the appropriate rate.
                            </p>
                        </li>
                    </ol>
                </li>
            </ol>
        </li>
        <li data-list-text="11.">
            <h3 style="padding-top: 1pt; text-align: justify;"><a name="bookmark64">‌</a>Proprietary rights</h3>
            <ol id="l18">
                <li data-list-text="11.1">
                    <p style="padding-top: 1pt; padding-left: 48pt; text-indent: -38pt; text-align: justify;">
                        <a href="#bookmark69" class="a" name="bookmark65">Subject to clause </a>11.2, the Customer acknowledges and agrees that QuiX Quantum and/or its licensors own all Intellectual Property Rights in the Services, the
                        Documentation and any Derived Data. Except as expressly stated herein, this Agreement does not grant the Customer any Intellectual Property Rights in respect of the Services or the Documentation.
                    </p>
                </li>
                <li data-list-text="11.2">
                    <p style="padding-left: 48pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark66">‌</a>To the extent that any Intellectual Property Rights are created or developed in the Derived Data that may be used to improve the Platform, such Intellectual Property Rights shall be owned by
                        QuiX Quantum.<a name="bookmark69">‌</a>
                    </p>
                </li>
                <li data-list-text="11.3">
                    <p style="padding-top: 2pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a href="#bookmark69" class="a" name="bookmark67">Except for any Intellectual Property Rights referred to in clause </a>11.2, any Intellectual Property Rights that are created or developed in the Derived Data shall
                        be owned by the Customer.
                    </p>
                </li>
                <li data-list-text="11.4">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark68">‌</a>QuiX Quantum reserves the right to be named in publications citing calculations, Derived Data or results generated in the provision of the Services.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="12.">
            <h3 style="padding-top: 1pt; text-align: justify;"><a name="bookmark70">‌</a>Confidentiality<a name="bookmark90">‌</a></h3>
            <ol id="l19">
                <li data-list-text="12.1">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a href="#bookmark92" class="a" name="bookmark71">Subject to clause </a><a href="#bookmark93" class="a">12.2 and </a><a href="#bookmark93">12.3:</a><a name="bookmark91">‌</a>
                    </p>
                    <ol id="l20">
                        <li data-list-text="(a)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark72">‌</a>each Party (the <b>Recipient</b>) shall keep confidential the other Party’s (the <b>Disclosing Party</b>) Confidential Information disclosed to it by or on behalf of the Disclosing
                                Party or otherwise obtained, developed or created by Recipient;
                            </p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark73">‌</a>the Recipient shall use the Confidential Information solely in connection with the performance of its obligations or exercise of its rights under this Agreement and take all
                                reasonable steps to ensure that the other's Confidential Information to which it has access is not disclosed or distributed by its employees or agents in violation of the terms of this Agreement.
                            </p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="12.2">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a href="#bookmark91" class="a" name="bookmark74">The restrictions on use or disclose of information in clause </a><a href="#bookmark91">12.1</a><a name="bookmark92">‌</a>
                    </p>
                    <p style="padding-left: 43pt; text-indent: 0pt; text-align: justify;">do not apply to information which :</p>
                    <ol id="l21">
                        <li data-list-text="(a)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark75">‌</a>is or becomes generally available in the public domain, other than through any act or omission of the Recipient;
                            </p>
                            <p style="text-indent: 0pt; text-align: right;"></p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark76">‌</a>was in the Recipient’s lawful possession before the disclosure;</p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark77">‌</a>is lawfully disclosed to the Recipient by a third party who owns no obligation of confidence in respect of the information; or
                            </p>
                        </li>
                        <li data-list-text="(d)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark78">‌</a>is independently developed by the Recipient, which independent development can be shown by written evidence.
                            </p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="12.3">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;"><a name="bookmark79">‌</a>The Recipient may disclose Confidential Information:<a name="bookmark93">‌</a></p>
                    <ol id="l22">
                        <li data-list-text="(a)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a href="#bookmark94" class="a" name="bookmark80">subject to clause </a>12.4, to its affiliates, representatives and subcontractors, to whom disclosure is required for the performance of the Recipient's
                                obligations or the exercise of its rights under this Agreement, but only to the extent necessary to perform such obligations or exercise such rights (together the <b>Permitted Disclosees</b>); or
                            </p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark81">‌</a>if, and to the extent, such Confidential Information is required to be disclosed by law, by any governmental or other regulatory authority or by a court or other authority of
                                competent jurisdiction (<b>Relevant Authority</b>
                                <a href="#bookmark93" class="a">
                                    ) to which the Recipient is subject, provided that, to the extent it is legally permitted to do so, the Recipient gives the Disclosing Party as much notice of such disclosure as possible and, where notice
                                    of disclosure is not prohibited and is given in accordance with this clause
                                </a>
                                <a href="#bookmark93" class="s5">12.3</a>, it takes into account the reasonable requests of the Disclosing Party in relation to the content of such disclosure.
                            </p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="12.4">
                    <p style="padding-top: 2pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;"><a name="bookmark82">‌</a>The Recipient shall:<a name="bookmark94">‌</a></p>
                    <ol id="l23">
                        <li data-list-text="(a)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark83">‌</a>before disclosing Confidential Information to a Permitted Disclosee, notify the Disclosing Party of the intended disclosure and the identity of the intended Permitted Disclosee;
                            </p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a href="#bookmark90" class="a" name="bookmark84">ensure that such Permitted Disclosee is aware of and complies with the Recipient’s obligations under this clause </a>12 as if it were the Recipient; and
                            </p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark85">‌</a>be responsible for the acts and omissions of any Permitted Disclosee in relation to Confidential Information of the Recipient as if they were its own acts or omissions.
                            </p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="12.5">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark86">‌</a>The Customer acknowledges that any information related to the functioning of the Platform or the Services constitute QuiX Quantum's Confidential Information.
                    </p>
                </li>
                <li data-list-text="12.6">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;"><a name="bookmark87">‌</a>QuiX Quantum acknowledges that the Customer Data is the</p>
                </li>
                <li data-list-text="12.7">
                    <p style="padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark88">‌</a>No party shall make, or permit any person to make, any public announcement concerning this agreement without the prior written consent of the other party (such consent not to be unreasonably
                        withheld or delayed), except as required by law, any governmental or regulatory authority (including, without limitation, any relevant securities exchange), any court or other authority of competent jurisdiction.
                    </p>
                </li>
                <li data-list-text="12.8">
                    <p style="padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a href="#bookmark90" class="a" name="bookmark89">The above provisions of this clause </a><span style="">12</span><span class="p"> shall survive termination this Agreement, however arising.</span>
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="13.">
            <h3 style="padding-top: 1pt; text-align: justify;"><a name="bookmark95">‌</a>Indemnity</h3>
            <ol id="l24">
                <li data-list-text="13.1">
                    <p style="padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark96">‌</a>The Customer shall defend, indemnify and hold harmless QuiX Quantum against claims, actions, proceedings, losses, damages, expenses and costs (including without limitation court costs and
                        reasonable professional advisor’s fees and disbursements) arising out of or in connection with the Customer's use of the Services and/or Documentation, provided that:
                    </p>
                    <ol id="l25">
                        <li data-list-text="(a)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark97">‌</a>the Customer is given prompt notice of any such claim;</p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark98">‌</a>QuiX Quantum provides reasonable co-operation to the Customer in the defence and settlement of such claim, at the Customer's expense; and
                            </p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark99">‌</a>the Customer is given sole authority to defend or settle the claim.</p>
                            <p style="padding-left: 71pt; text-indent: 0pt; text-align: justify;"></p>
                        </li>
                    </ol>
                </li>
            </ol>
        </li>
        <li data-list-text="14.">
            <h3 style="padding-top: 1pt; text-align: justify;"><a name="bookmark100">‌</a>Limitation of liability</h3>
            <ol id="l26">
                <li data-list-text="14.1">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;"><a name="bookmark101">‌</a>Except as expressly and specifically provided in this Agreement:</p>
                    <ol id="l27">
                        <li data-list-text="(a)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark102">‌</a>the Customer assumes sole responsibility for results obtained from the use of the Services and the Documentation by the Customer, and for conclusions drawn from such use. QuiX
                                Quantum shall have no liability for any damage caused by errors or omissions in any information, instructions or scripts provided to QuiX Quantum by the Customer in connection with the Services, or any
                                actions taken by QuiX Quantum at the Customer's direction;
                            </p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-top: 2pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark103">‌</a>all warranties, representations, conditions and all other terms of any kind whatsoever implied by law are, to the fullest extent permitted by Applicable Law, excluded from this
                                Agreement; and
                            </p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark104">‌</a>the Services and the Documentation are provided to the Customer on an "as is, where is" basis only.</p>
                            <p style="padding-left: 71pt; text-indent: 0pt; text-align: justify;"></p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="14.2">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;"><a name="bookmark105">‌</a>Nothing in this Agreement excludes a Party’s liability:<a name="bookmark110">‌</a></p>
                    <ol id="l28">
                        <li data-list-text="(a)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark106">‌</a>for death or personal injury caused by negligence;</p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-top: 1pt; padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark107">‌</a>for fraud or fraudulent misrepresentation; or</p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-left: 71pt; text-indent: -28pt; text-align: justify;"><a name="bookmark108">‌</a>to the extent it cannot be legally limited or excluded by law.</p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="14.3">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a href="#bookmark110" class="a" name="bookmark109">Subject to clause </a><a href="#bookmark110" class="s5">14.2</a>, QuiX Quantum’s liability (whether in contract, tort (including negligence) or otherwise) to the
                        Customer or any other person for any claim, liability, costs, expenses, damages or losses of any kind arising from or relating to this Agreement including under any indemnity or warranty and any consequential damages
                        (including for the avoidance of doubt any damages resulting from third-party claims, loss of revenue of profits, loss of business, loss of anticipated savings, loss of goodwill, or loss or corruption of data) shall
                        be limited to the fees paid by the Customer in the six (6) months prior to such claim arising.<a name="bookmark111">‌</a>
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="15.">
            <h3 style="; text-align: justify;"><a name="bookmark112">‌</a>Term and termination<a name="bookmark117">‌</a></h3>
            <ol id="l29">
                <li data-list-text="15.1">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a href="#bookmark117" class="a" name="bookmark113">This Agreement shall commence on the Effective Date and shall continue until terminated in accordance with this clause </a><a href="#bookmark117" class="s5">15</a>
                        <a href="#bookmark117">.</a>
                    </p>
                </li>
                <li data-list-text="15.2">
                    <p style="padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark114">‌</a>Either party may terminate this Agreement for any reason by providing at least thirty (30) days written notice to the other party.
                    </p>
                </li>
                <li data-list-text="15.3">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark115">‌</a>Without affecting any other right or remedy available to it, either Party may terminate this Agreement with immediate effect by giving written notice to the other Party if:
                        <a name="bookmark118">‌</a>
                    </p>
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: 0pt; text-align: justify;">
                        <a name="bookmark116">‌</a>the other Party commits a material breach of any other term of this Agreement which breach is irremediable or (if such breach is remediable) fails to remedy that breach within a period of
                        thirty (30) days after being notified in writing to do so.</p>
                </li>
            </ol>
        </li>
        <li data-list-text="16.">
            <h3 style="padding-top: 2pt; ; text-align: justify;"><a name="bookmark119">‌</a>Entire agreement</h3>
            <ol id="l30">
                <li data-list-text="16.1">
                    <p style="padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark120">‌</a>The parties hereto confirm and agree that this Agreement (including the premises hereto) is the entire and complete agreement between them, and that this Agreement supersedes any previous
                        oral or written communications, negotiations, representations, understandings or agreements between the parties with respect to the subject matter hereof.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="17.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark121">‌</a>Invalid provisions</h3>
            <ol id="l31">
                <li data-list-text="17.1">
                    <p style="padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark122">‌</a>In the event that a provision of this Agreement is null and void or unenforceable (either in whole or in part), the remainder of this Agreement shall continue to be effective to the extent
                        that, given this Agreement's substance and purpose, such remainder is not inextricably related to the null and void or unenforceable provision. The parties shall make every effort to reach agreement on a new
                        provision which differs as little as possible from the null and void or unenforceable provision, taking into account the substance and purpose of this Agreement.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="18.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark123">‌</a>Modifications to Agreement</h3>
            <ol id="l32">
                <li data-list-text="18.1">
                    <p style="padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        QuiX Quantum is entitled to reasonably amend and/or supplement this Agreement and/or these Terms and Conditions in the event of changes in applicable laws and regulations, changes in the Services of QuiX, technical, commercial changes and/or changing market conditions.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="19.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark125">‌</a>Counterparts</h3>
            <ol id="l33">
                <li data-list-text="19.1">
                    <p style="padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark126">‌</a>This Agreement may be executed in any number of counterparts, each of which when executed and delivered shall constitute a duplicate original, but all the counterparts shall together
                        constitute the one agreement.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="20.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark127">‌</a>Governing law</h3>
            <ol id="l34">
                <li data-list-text="20.1">
                    <p style="padding-top: 1pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark128">‌</a>This Agreement and any dispute or claim arising out of or in connection with it or its subject matter or formation (including non-contractual disputes or claims) shall be governed by and
                        construed in accordance with the law of the Netherlands.
                    </p>
                </li>
            </ol>
        </li>
        <li data-list-text="21.">
            <h3 style="padding-top: 1pt; ; text-align: justify;"><a name="bookmark129">‌</a>Jurisdiction</h3>
            <ol id="l35">
                <li data-list-text="21.1">
                    <p style="padding-left: 43pt; text-indent: -38pt; text-align: justify;">
                        <a name="bookmark130">‌</a>The parties irrevocably agree that the District Courts of Amsterdam shall have exclusive jurisdiction to settle any dispute or claim that arises out of or in connection with this agreement
                        or its subject matter or formation (including non-contractual disputes or claims).
                    </p>
                </li>
            </ol>
        </li>
    </ol>
    <p style="text-indent: 0pt; text-align: left;"><br /></p>
    <p class="s6" style="padding-top: 4pt; padding-left: 12pt; text-indent: 0pt;"><a name="bookmark131">‌</a>Schedule 1<a name="bookmark155">‌</a></p>
    <h1 style="padding-top: 6pt; padding-left: 12pt; text-indent: 0pt;">Data Processing Agreement</h1>
    <p class="s7" style="padding-top: 8pt; padding-left: 59pt; text-indent: 0pt; text-align: left; font-size: 12pt"><a name="bookmark132">‌</a>Processing, Personal Data and Data Subjects</p>
    <p style="padding-top: 1pt; text-indent: 0pt; text-align: left;"><br /></p>
    <table style="border-collapse: collapse; margin-left: 59.25pt;" cellspacing="0">
        <tbody>
            <tr style="height: 45pt;">
                <td
                    style="
                        width: 158pt;
                        border: 1px solid white
                    "
                >
                    <p class="s8" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Processing by QuiX Quantum:</p>
                </td>
                <td
                    style="
                        width: 350pt;
                        border: 1px solid white
                    "
                >
                    <p class="s9" style="padding-left: 5pt; padding-right: 4pt; text-indent: 0pt; text-align: justify;">
                        QuiX Quantum collects and stores certain personal data of representatives of the Customer in order to set up the Customer’s account and maintain the Customer’s access to the Service.
                    </p>
                </td>
            </tr>
            <tr style="height: 35pt;">
                <td
                    style="
                        width: 158pt;
                        border: 1px solid white
                    "
                >
                    <p class="s8" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Scope:</p>
                </td>
                <td
                    style="
                        width: 310pt;
                        border: 1px solid white
                    "
                >
                    <p class="s9" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">The Processor provides a web service to allow the Customer to carry out photonic
                    quantum calculations by submitting tasks through its platform.</p>
                </td>
            </tr>
            <tr style="height: 23pt;">
                <td
                    style="
                        width: 158pt;
                        border: 1px solid white
                    "
                >
                    <p class="s8" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Nature:</p>
                </td>
                <td
                    style="
                        width: 310pt;
                        border: 1px solid white
                    "
                >
                    <p class="s9" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Collecting, storing, saving, transferring and deleting data.</p>
                </td>
            </tr>
            <tr style="height: 35pt;">
                <td
                    style="
                        width: 158pt;
                        border: 1px solid white
                    "
                >
                    <p class="s8" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Purpose of processing:</p>
                </td>
                <td
                    style="
                        width: 310pt;
                       border: 1px solid white
                    "
                >
                    <p class="s9" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Processing is necessary for a Customer representative to successfully register an
                    account in order to submit tasks to the quantum photonic processor.</p>
                </td>
            </tr>
            <tr style="height: 34pt;">
                <td
                    style="
                        width: 158pt;
                        border: 1px solid white
                    "
                >
                    <p class="s8" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Duration of the processing:</p>
                </td>
                <td
                    style="
                        width: 310pt;
                        border: 1px solid white
                    "
                >
                    <p class="s9" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">The duration of the processing will be carried out for an unspecified period until
                    the Customer deletes, or requests QuiX Quantum to delete this data or account.</p>
                </td>
            </tr>
            <tr style="height: 34pt;">
                <td
                    style="
                        width: 158pt;
                        border: 1px solid white
                    "
                >
                    <p class="s8" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Types of personal data:</p>
                </td>
                <td
                    style="
                        width: 310pt;
                        border: 1px solid white
                    "
                >
                    <p class="s9" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Forename(s) and surname, IP address, telephone number (personal and/or
                    business), e-mail address (personal and/or business).</p>
                </td>
            </tr>
            <tr style="height: 23pt;">
                <td
                    style="
                        width: 158pt;
                        border: 1px solid white
                    "
                >
                    <p class="s8" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Categories of data subject:</p>
                </td>
                <td
                    style="
                        width: 310pt;
                        border: 1px solid white
                    "
                >
                    <p class="s9" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Application end-users, Customer representatives, website end-users.</p>
                </td>
            </tr>
            <tr style="height: 23pt;">
                <td
                    style="
                        width: 158pt;
                       border: 1px solid white
                    "
                >
                    <p class="s8" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">Sub-processors:</p>
                </td>
                <td
                    style="
                        width: 310pt;
                        border: 1px solid white
                    "
                >
                    <p class="s9" style="padding-left: 5pt; text-indent: 0pt; text-align: left;">[<span class="s10"></span>]</p>
                </td>
            </tr>
        </tbody>
    </table>
    <p style="text-indent: 0pt; text-align: left;"><br /></p>
    <ol id="l36">
        <li data-list-text="1.">
            <h2 style="; text-align: justify;"><a name="bookmark133">‌</a>Data Processing Agreement – Applicable terms<a name="bookmark156">‌</a></h2>
            <ol id="l37">
                <li data-list-text="1.1">
                    <p style="padding-top: 1pt; padding-left: 87pt; text-indent: -33pt; text-align: justify;"><a name="bookmark134">‌</a>The Parties acknowledge that:<a name="bookmark157">‌</a></p>
                    <ol id="l38">
                        <li data-list-text="(a)">
                            <p style="padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark135">‌</a>QuiX Quantum acts as Controller when processing personal data for the purposes of setting up a Customer’s account, including when processing personal data belonging to Customer
                                representative(s) who sets up an account on the Customer’s behalf;<a name="bookmark158">‌</a>
                            </p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-top: 1pt; padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a href="#bookmark157" class="a" name="bookmark136">except as set out in paragraph </a><a href="#bookmark158" class="a">1.1</a><a href="#bookmark155" class="a">(a) of this </a>Schedule 1 (
                                <i>Data Protection Schedule</i>), QuiX Quantum acts as a Processor with respect to personal data processed under this Agreement;
                            </p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-top: 1pt; padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark137">‌</a>The table (<i>Processing, Personal Data and Data Subjects</i>) of this Schedule 1 (<i>Data Processing Agreement</i>) sets out the scope, nature and purpose of processing by QuiX
                                Quantum, the duration of the processing and the types of personal data and categories of data subject; and
                            </p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="1.2">
                    <p style="padding-top: 1pt; padding-left: 87pt; text-indent: -34pt; text-align: justify;">
                        <a href="#bookmark43" class="a" name="bookmark138">Without prejudice to the generality of clause </a>7.1, QuiX Quantum shall, where acting as Processor, and in relation to any personal data processed in connection
                        with the performance by QuiX Quantum of its obligations under this Agreement:<a name="bookmark159">‌</a>
                    </p>
                    <ol id="l39">
                        <li data-list-text="(a)">
                            <p style="padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark139">‌</a>process that personal data only on the documented written instructions of the Customer unless QuiX Quantum is required by Data Protection Laws to process personal data. Customer
                                instructs QuiX Quantum to process personal data to perform the Services and as described in this Agreement, and Customer shall ensure that any instructions it issues to QuiX Quantum shall comply with Data
                                Protection Laws;
                            </p>
                        </li>
                        <li data-list-text="(b)">
                            <p style="padding-top: 1pt; padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark140">‌</a>QuiX Quantum shall inform Customer if, in its reasonable opinion, an instruction issued by Customer infringes Data Protection Laws and shall, without liability, be entitled to stop
                                processing personal data in accordance with such infringing instruction. The Parties acknowledge and agree that a failure or delay by QuiX Quantum to identify that
                            </p>
                            <p style="padding-top: 2pt; padding-left: 115pt; text-indent: 0pt; text-align: justify;">an instruction infringes Data Protection Laws shall not cause QuiX Quantum to be in breach of this Agreement nor</p>
                            <p style="padding-left: 115pt; text-indent: 0pt; text-align: justify;">relieve Customer from its liability under this Agreement;</p>
                        </li>
                        <li data-list-text="(c)">
                            <p style="padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a href="#bookmark159" class="a" name="bookmark141">Subject to the remainder of this paragraph </a><a href="#bookmark160" class="a">1.2</a>(c), Customer consents to transfers of personal data to QuiX
                                Quantum’s sub-processors based in countries outside the European Economic Area. Where QuiX Quantum transfers personal data, either directly or via onward transfer, from the EEA to a recipient outside the EEA
                                in a country not recognised by the European Commission as providing an adequate level of protection for personal data (“<b>Third Country Recipient</b>”), such transfer shall be covered by a framework
                                recognised by the relevant authorities or courts as providing an adequate level of protection for personal data, including but not limited to Standard Contractual Clauses or binding corporate rules (each a “
                                <b>Data Transfer Mechanism</b>”). If QuiX Quantum elects to apply the Standard Contractual Clauses:<a name="bookmark160">‌</a>
                            </p>
                            <ol id="l40">
                                <li data-list-text="(i)">
                                    <p style="padding-left: 144pt; text-indent: -28pt; text-align: justify;">
                                        <a name="bookmark142">‌</a>if required by QuiX Quantum, Customer shall sign a copy of the Standard Contractual Clauses and take such further action as is required by applicable law to ensure that the
                                        Standard Contractual Clauses are legally valid;
                                    </p>
                                </li>
                                <li data-list-text="(ii)">
                                    <p style="padding-top: 1pt; padding-left: 143pt; text-indent: -28pt; text-align: justify;">
                                        <a name="bookmark143">‌</a>they shall constitute a separate agreement between each Data Exporter and the Data Importer;
                                    </p>
                                </li>
                                <li data-list-text="(iii)">
                                    <p style="padding-left: 144pt; text-indent: -28pt; text-align: justify;">
                                        <a href="#bookmark161" class="a" name="bookmark144">
                                            the Parties agree that the prior written consent to the engagement of sub-processors required by Clause 5(h) of the Standard Contractual Clauses has been given pursuant to paragraph
                                        </a>
                                        1.4; and
                                    </p>
                                </li>
                                <li data-list-text="(iv)">
                                    <p style="padding-top: 1pt; padding-left: 144pt; text-indent: -28pt; text-align: justify;">
                                        <a name="bookmark145">‌</a>the Parties agree that upon Data Exporter’s request, Data Importer will provide the copies of the sub- processor agreements that must be sent by the Data Importer to the
                                        Data Exporter pursuant to Clause 5(j) of the Standard Contractual Clauses, and that Data Importer may remove or redact all commercial information or clauses unrelated to the Standard Contractual
                                        Clauses or their equivalent beforehand;
                                    </p>
                                </li>
                            </ol>
                        </li>
                        <li data-list-text="(d)">
                            <p style="padding-top: 1pt; padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark146">‌</a>to the extent permitted by law, promptly notify Customer upon receipt of a complaint or request from a data subject, and provide such commercially reasonable assistance as Customer
                                may reasonably request to help Customer fulfil its obligations under Data Protection Laws to respond to such complaints or requests. Customer shall be responsible for any costs arising from QuiX Quantum’s
                                provision of such assistance;
                            </p>
                        </li>
                        <li data-list-text="(e)">
                            <p style="padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark147">‌</a>QuiX Quantum shall notify Customer of all enquiries from a Regulator that QuiX Quantum receives which relate to the processing of personal data, the provision or receipt of the
                                Services or either Party's obligations under the Agreement, unless prohibited from doing so at law or by the Regulator. Unless a Regulator requests in writing to engage directly with QuiX Quantum, the Parties
                                (acting reasonably and taking into account the subject matter of the request) agree that the Customer shall handle a Regulator request itself. The Customer shall: (a) be responsible for all communications or
                                correspondence with the Regulator in relation to the processing of personal data and the provision or receipt of the Services; and (b) keep QuiX Quantum informed of such communications or correspondence to
                                the extent permitted by law;
                            </p>
                        </li>
                        <li data-list-text="(f)">
                            <p style="padding-top: 1pt; padding-left: 115pt; text-indent: -28pt; text-align: justify;"><a name="bookmark148">‌</a>notify the Customer without undue delay on becoming aware of a personal data breach;</p>
                        </li>
                        <li data-list-text="(g)">
                            <p style="padding-top: 1pt; padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a name="bookmark149">‌</a>at the written direction of the Customer, delete or return personal data and copies thereof to the Customer on termination of the Agreement unless required by Applicable Law to
                                store the personal data (and for these purposes the term "delete" shall mean to put such data beyond use); and
                            </p>
                        </li>
                        <li data-list-text="(h)">
                            <p style="padding-top: 1pt; padding-left: 115pt; text-indent: -28pt; text-align: justify;">
                                <a href="#bookmark159" class="a" name="bookmark150">maintain complete and accurate records and information to demonstrate its compliance with this paragraph </a><a href="#bookmark159">1.2.</a>
                            </p>
                        </li>
                    </ol>
                </li>
                <li data-list-text="1.3">
                    <p style="padding-top: 1pt; padding-left: 87pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark151">‌</a>QuiX Quantum shall take the appropriate technical and organisational measures to protect the confidentiality, integrity, availability and resilience of QuiX Quantum systems which are
                        involved in processing personal data. Customer has assessed the level of security appropriate to the processing in the context of its obligations under Data Protection Laws and agrees that the security measures are
                        consistent with such assessment.
                    </p>
                </li>
                <li data-list-text="1.4">
                    <p style="padding-left: 87pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark152">‌</a>The Customer consents to QuiX Quantum appointing the entities set out in the table <i>(Processing, Personal Data and Data Subjects</i>) of Schedule 1 (<i>Data processing agreement</i>
                        <a href="#bookmark156" class="a">
                            ) as processors (where QuiX Quantum acts as Controller) or sub- processors (where QuiX Quantum acts as Processor) of personal data under this Agreement. QuiX Quantum shall ensure that its contract with any
                            sub-processor will contain substantially similar provisions to this paragraph
                        </a>
                        <a href="#bookmark156">1.</a><a name="bookmark161">‌</a>
                    </p>
                </li>
                <li data-list-text="1.5">
                    <p style="padding-top: 1pt; padding-left: 87pt; text-indent: -34pt; text-align: justify;">
                        <a name="bookmark153">‌</a>QuiX Quantum shall notify the Customer prior to granting any sub-processor not included in such list access to personal data. If the Customer objects to QuiX Quantum's use of a new
                        sub-processor on reasonable grounds that the new sub- processor is unlikely to be able to comply with the terms of this Agreement, the Customer shall notify QuiX Quantum promptly in writing within ten (10) days after
                        receipt of QuiX Quantum's notice. The Customer acknowledges that the inability to use a particular new sub-processor may result in delay in performing the Services, inability to perform the Services or increased
                        fees.
                    </p>
                </li>
            </ol>
        </li>
    </ol>
    <p style="padding-top: 2pt; padding-left: 43pt; text-indent: -38pt; text-align: justify;">
        <a href="#bookmark156" class="a" name="bookmark154"><span style="font-size: 14pt;">21.2</span> Either Party may, at any time on not less than thirty (30) days' notice, revise this paragraph </a>1 by replacing it with any applicable
        controller to processor standard clauses or similar terms forming part of an applicable certification scheme (which shall apply when replaced by attachment to this Agreement).
    </p>
    <p style="text-indent: 0pt; text-align: left;"><br /></p>
</body>
`;

function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={classes.container}>
      {/* Quix Image */}
      <Link to={"/register"} className={classes.logoContainer}>
        <Image src={QuixLogo} alt="Quix Logo" preview={false} />
      </Link>

      <div dangerouslySetInnerHTML={{ __html: termsAndConditions }}></div>
    </div>
  );
}

export default TermsAndConditions;
